/* Progressive enhancement only: all chapters and anchor links work without JS. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready || !('IntersectionObserver' in window)) return;
    root.dataset.ready = 'true';
    const chapters = [...root.querySelectorAll('.mwd__chapter')];
    const links = [...root.querySelectorAll('[data-chapter-link]')];
    const active = new Map();
    const select = (id) => links.forEach(link => {
      if (link.dataset.chapterLink === id) link.setAttribute('aria-current', 'step');
      else link.removeAttribute('aria-current');
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => active.set(entry.target.id, entry.isIntersecting));
      const current = chapters.find(chapter => active.get(chapter.id));
      if (current) select(current.id);
    }, {rootMargin: '-18% 0px -50% 0px', threshold: 0});
    chapters.forEach(chapter => observer.observe(chapter));
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-chapter-link]');
      if (link) select(link.dataset.chapterLink);
    });
    const section = root.closest('.shopify-section');
    if (section) section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
  };
  document.querySelectorAll('.mwd').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.mwd')));
})();
